/**
 * Created by Andrey Popov on 08.08.25
 */

const Stock = function () {
    this.data = {};
};

Stock.prototype.onUnitAvailable = function (unit) {
    if (Stock.IGNORES_STOCK.indexOf(unit.code) !== -1 || !Buildable.IsBuilt(unit) || !Creatable.IsCreated(unit) || unit.isGrounded()) {
        return;
    }

    if (unit.stocked > 0) {
        // cleverapps.throwAsync(`Unit added second time ${Unit.GetKey(unit)}`);
        return;
    }

    const key = Unit.GetKey(unit);

    const mapUnit = Map2d.currentMap.getUnit(unit.x, unit.y);
    if (!mapUnit || Unit.GetKey(mapUnit) !== key) {
        return;
    }

    this.data[key] = (this.data[key] || 0) + 1;

    unit.stocked = 1;

    Map2d.currentMap.customers.updateMarks();
    Map2d.currentMap.customers.onRecipesUpdated();
};

Stock.prototype.onUnitRemoved = function (unit) {
    if (unit.stocked < 1) {
        // cleverapps.throwAsync(`Unit removed second time ${Unit.GetKey(unit)}`);
        return;
    }

    if (!unit.stocked) {
        return;
    }

    const key = Unit.GetKey(unit);
    this.data[key] = (this.data[key] || 0) - 1;

    unit.stocked -= 1;

    Map2d.currentMap.customers.updateMarks();
    Map2d.currentMap.customers.onRecipesUpdated();
};

Stock.prototype.getStockAmount = function (ingredient) {
    if (ingredient.ingredient && Map2dLocation.currentLocation.harvested) {
        return Map2dLocation.currentLocation.harvested.get(ingredient.ingredient) || 0;
    }

    if (ingredient.unit) {
        return this.data[Unit.GetKey(ingredient.unit)] || 0;
    }

    return 0;
};

Stock.prototype.takeIngredients = function (ingredients, options) {
    options = options || {};
    const units = [];
    const resources = {};
    const customer = options.customer;
    const callback = options.callback || function () {};

    const unitsToRemove = {};

    ingredients.forEach((ingredient) => {
        if (ingredient.unit) {
            unitsToRemove[Unit.GetKey(ingredient.unit)] = ingredient.amount;
        }

        if (ingredient.ingredient) {
            resources[ingredient.ingredient] = (resources[ingredient.ingredient] || 0) + ingredient.amount;
        }
    });

    Map2d.currentMap.listAvailableUnits((unit) => {
        const key = Unit.GetKey(unit);
        if (unit.stocked && unitsToRemove[key]) {
            unitsToRemove[key] -= 1;
            units.push(unit);
        }
    });

    Map2dLocation.currentLocation.harvested && Map2dLocation.currentLocation.harvested.takeList(resources);

    Map2dLocation.currentLocation.counter.inc();
    const waitCallback = cleverapps.wait(units.length, () => {
        callback();
        Map2dLocation.currentLocation.counter.dec();
    });

    units.forEach((unit) => {
        unit.setCustomerMark(false);
        unit.takePrizes();
        unit.setPrizes();

        if (unit.points) {
            unit.claimPoints();
        }

        const pulsing = unit.findComponent(Pulsing);
        if (pulsing) {
            pulsing.setRemoved(true);
        }

        if (customer) {
            customer.collectUnit(unit, waitCallback);
        } else {
            unit.remove();
            waitCallback();
        }
    });
};

Stock.prototype.canTakeIngredients = function (ingredients) {
    for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];

        if (this.getStockAmount(ingredient) < ingredient.amount) {
            return false;
        }
    }
    return true;
};

Stock.prototype.getLackingAmount = function (ingredient) {
    return Math.max(0, ingredient.amount - this.getStockAmount(ingredient));
};

Stock.prototype.canSpawnIngredients = function (ingredients, lacking) {
    const unitsAmount = ingredients.reduce((total, ingredient) => {
        if (ingredient.unit) {
            return total + (lacking ? this.getLackingAmount(ingredient) : ingredient.amount);
        }
        return total;
    }, 0);

    const cellsToFree = unitsAmount - Map2d.currentMap.countEmptySlots();

    if (cellsToFree > 0) {
        cleverapps.centerHint.createTextHint(Messages.get("Spawn.nospace", { left: cellsToFree }));
        return false;
    }
    return true;
};

Stock.prototype.spawnIngredients = function (ingredients, lacking) {
    const cell = Map2d.currentMap.getScreenCenterCell();

    for (let i = 0; i < ingredients.length; i++) {
        const ingredient = ingredients[i];
        const amount = lacking ? this.getLackingAmount(ingredient) : ingredient.amount;

        if (ingredient.unit) {
            for (let j = 0; j < amount; ++j) {
                const slot = Map2d.currentMap.findEmptySlot(cell.x, cell.y);

                const unit = new Unit(ingredient.unit);
                unit.setPosition(slot.x, slot.y);
                Map2d.currentMap.add(Map2d.LAYER_UNITS, unit.x, unit.y, unit);
                Map2d.currentMap.onAddUnit(unit.x, unit.y, unit);
                Map2d.currentMap.onUnitAvailable(unit);
            }
        }

        if (ingredient.ingredient && Map2dLocation.currentLocation.harvested) {
            Map2dLocation.currentLocation.harvested.add(ingredient.ingredient, amount);
        }
    }
};

Stock.IGNORES_STOCK = ["unknown", "multiCellBody", "thirdelement", "t", "barrel", "caravanship", "drgrowing"];
